export type Consent = {
  necessary: true;
  analytics: boolean;
};

const KEY = "cookie_consent";

// wenn du früher andere Keys hattest:
const LEGACY_KEYS = ["cookie_consent_v1", "cookie_consent_v2", "cookie_consent_v3"];

function isConsent(x: any): x is Consent {
  return x && x.necessary === true && typeof x.analytics === "boolean";
}

export function loadConsent(): Consent | null {
  try {
    // 1) neuer Key
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      const maybe = parsed?.consent ?? parsed; // akzeptiert altes {consent:{...}} und neues {...}
      return isConsent(maybe) ? maybe : null;
    }

    // 2) legacy keys (migrieren)
    for (const k of LEGACY_KEYS) {
      const r = localStorage.getItem(k);
      if (!r) continue;
      const parsed = JSON.parse(r);
      const maybe = parsed?.consent ?? parsed;
      if (isConsent(maybe)) {
        // migrieren auf neuen Key
        localStorage.setItem(KEY, JSON.stringify(maybe));
        return maybe;
      }
    }

    return null;
  } catch {
    return null;
  }
}

export function saveConsent(consent: Consent): Consent {
  localStorage.setItem(KEY, JSON.stringify(consent));
  return consent;
}

export function clearConsent(): void {
  localStorage.removeItem(KEY);
}
